import RestProvider from 'providers/RestProvider';
import { properties } from './CompAutoData';

export default function CompAutoFunctions() {
    const { crudOperation, crudOperationsType } = RestProvider();

    /**
     * @function getSolicitantesPuntosHistorico Función que obtiene los datos historicos del solicitante
     * @param {*} nif
     * @returns 
     */
    const getSolicitantesPuntosHistorico = async (nif) => {
        let res = null;

        if (nif !== undefined && nif !== null) {
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url: `${properties.urlSolicitantesPuntosHistorico}${nif}`, method: 'get' }).then(response => {
                res = response.data;
            });
        }
        return res;
    }

    return { getSolicitantesPuntosHistorico };
}
